import type React from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { PageAdminTools } from '../components/PageAdminTools';
import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<ClientRender>
				<PageAdminTools />
			</ClientRender>
			<div className="container pb-10">
				<PageHeading />
				<PageBody />
			</div>
		</>
	);
};
